import React, { useState } from 'react';

function Question({ question, handleAnswerOptionClick, handleNextButtonClick }) {
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);

  const handleAnswerClick = (answerOption, index) => {
    setSelectedAnswer(index);
  }

  const handleNextClick = () => {
    setShowFeedback(true);
    // If you want to update the score here, you can do:
    handleAnswerOptionClick(question.answerOptions[selectedAnswer]);

    setTimeout(() => {
      handleNextButtonClick(); // Move to the next question
      setSelectedAnswer(null); // Clear the selected answer
      setShowFeedback(false);
    }, 500);
  }

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">{question.questionText}</h5>
        <div className="mb-3">
          {question.answerOptions.map((answerOption, index) => (
            <div 
              key={index} 
              className={`answer-box ${selectedAnswer === index ? "answer-box-selected" : ""} ${showFeedback && selectedAnswer === index ? (answerOption.isCorrect ? "answer-correct" : "answer-wrong") : ""}`}
              onClick={() => handleAnswerClick(answerOption, index)}
            >
              {answerOption.answerText}
            </div>
          ))}
        </div>
        <button className="btn btn-primary" onClick={handleNextClick}>Next</button>
      </div>
    </div>
  );
}

export default Question;
